"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSvg = _interopRequireDefault(require("react-svg"));

var _default = function _default() {
  return _react["default"].createElement(_reactSvg["default"], {
    path: "https://static.ux.cimpress.io/assets/images/page_error_404.svg"
  });
};

exports["default"] = _default;